// import 'styles/scss/index.scss'
import { Route, Routes } from 'react-router-dom';
import LandingPage from 'client/pages/LandingPage';
import VideoMakerPage from 'client/pages/VideoMakerPage';
import HowToPage from 'client/pages/HowToPage';
import Gallery from 'client/pages/Gallery';
import Login from 'client/pages/Login';
import LicencePage from 'client/pages/LicencePage';
import * as React from 'react';
import VideoLibrary from 'client/pages/VideoLibrary';
import PostDetails from 'client/pages/PostDetails';
import ResetPassword from 'client/pages/ResetPassword';
import ForgetPassword from 'client/pages/ForgetPassword';
import useNotification from 'client/hooks/useNotification';
import SharePage from 'client/pages/SharePage';
import NotFound from 'client/pages/NotFound';
import LegalNotivePage from 'client/pages/LegalNotivePage';
import TermsAndConditionsPage from 'client/pages/TermsAndConditionsPage';
import SEO from 'client/components/SEO';
import LoggedOutRoute from './LoggedOutRoute';
import PrivateRoute from './PrivateRoute';
import { useAppRouter } from './useAppRouter';
import UnhandledDynamicLinkRoute from './UnhandledDynamicLinkRoute';
import CategoryTourManagement from 'client/pages/CategoryTourManagement';

const NotificationContainer = () => {
  useNotification();

  return <></>;
};

const Root = () => {
  const { initiated } = useAppRouter();

  return initiated ? (
    <div>
      <NotificationContainer />
      <Routes>
        <Route path="/login" element={<LoggedOutRoute component={Login} />} />
        <Route path="/" element={<LandingPage />} />
        <Route path="/video-maker" element={<VideoMakerPage />} />
        <Route path="/how-to" element={<HowToPage />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/videos/:id" element={<PostDetails />} />
        <Route path="/share/:id" element={<SharePage />} />
        <Route path="/video-library" element={<PrivateRoute component={VideoLibrary} />} />
        <Route path="/category-tours" element={<PrivateRoute component={CategoryTourManagement} />} />
        <Route path="/resetpassword" element={<LoggedOutRoute component={ResetPassword} />} />
        <Route path="/forgetpassword" element={<LoggedOutRoute component={ForgetPassword} />} />
        <Route path="/legal-notice" element={<LegalNotivePage />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditionsPage />} />
        <Route path="/licence" element={<LicencePage />} />
        <Route path="/downloads" element={<UnhandledDynamicLinkRoute />} />
        <Route path="/welcome" element={<UnhandledDynamicLinkRoute />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  ) : (
    <div className="p-3 d-flex justify-content-center align-items-center vh-100">
      <SEO />
      <div
        className="spinner-border text-primary"
        style={{ width: '4rem', height: '4rem' }}
        role="status"
      />
    </div>
  );
};

export default Root;
